if (!customElements.get('hoculus-team-member')) {
    class HoculusTeamMember extends HTMLElement {
        constructor() {
            super();

            this.memberItems = Array.from(this.querySelectorAll('.team__member__item'));
            this.containerTags = this.querySelector('.container__tags');
            this.tagElements = Array.from(this.querySelectorAll('.container__tags .tags span'));
            this.popup = this.querySelector('.member__info__popup');
            this.popupContent = this.querySelector('.member__popup__content');
            this.overlay = this.querySelector('.member__info__overlay');
            this.closePopupButton = this.querySelector('.member__info__popup__close');

            this.activeTag = null;
            this.handleTagClick = this.handleTagClick.bind(this);
            this.handlePopupTriggerClick = this.handlePopupTriggerClick.bind(this);
            this.handleClosePopup = this.handleClosePopup.bind(this);
        }

        connectedCallback() {
            this.tagElements.forEach(tag => {
                tag.addEventListener('click', this.handleTagClick);
            });
            this.tagElements[0]?.classList.add('active');

            this.addEventListener('click', this.handlePopupTriggerClick);
            this.closePopupButton?.addEventListener('click', this.handleClosePopup);
            this.overlay?.addEventListener('click', this.handleClosePopup);
        }

        disconnectedCallback() {
            this.tagElements.forEach(tag => {
                tag.removeEventListener('click', this.handleTagClick);
            });
            
            this.removeEventListener('click', this.handlePopupTriggerClick);
            this.closePopupButton?.removeEventListener('click', this.handleClosePopup);
            this.overlay?.removeEventListener('click', this.handleClosePopup);
        }

        handleTagClick(event) {
            if (!this.memberItems.length) return;

            const clickedTag = event.currentTarget;
            const isAllTag = clickedTag === this.tagElements[0];

            if (isAllTag || this.activeTag === clickedTag) {
                this.activeTag?.classList.remove('active');
                this.activeTag = null;
                this.tagElements[0]?.classList.add('active');
                this.memberItems.forEach(memberItem => {
                    memberItem.classList.remove('is-filtered-out');
                });
                return;
            }

            const tagValue = clickedTag.textContent.trim().toLowerCase();

            if (this.activeTag) {
                this.activeTag.classList.remove('active');
            } else {
                this.tagElements[0].classList.remove('active');
            }

            this.activeTag = clickedTag;
            clickedTag.classList.add('active');

            this.memberItems.forEach(memberItem => {
                const member = memberItem.querySelector('.team__member');
                const skills = (member?.dataset.skills || '')
                    .toLowerCase()
                    .split(',')
                    .map(s => s.trim());

                const match = skills.includes(tagValue);
                memberItem.classList.toggle('is-filtered-out', !match);
            });
        }

        handlePopupTriggerClick(event) {
            if (!event.target.classList.contains('more-info-popup-trigger')) {
                return;
            }

            const memberItem = event.target.closest('.team__member__item');
            if (!memberItem) return;
            const memberId = memberItem.dataset.memberId;
            const template = this.querySelector(`template[data-member-id="${memberId}"]`);
            if (!template) return;

            const templateContent = template.content.cloneNode(true);
            this.popupContent.innerHTML = '';
            this.popupContent.appendChild(templateContent);
            
            this.popup?.classList.add('active');
            this.overlay?.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        handleClosePopup() {
            this.popup?.classList.remove('active');
            this.overlay?.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    customElements.define('hoculus-team-member', HoculusTeamMember);
}